import React, {createContext, useCallback, useContext, useEffect, useMemo, useRef, useState} from "react";

const DetailHeroSummaryContext = createContext(null);

export function DetailHeroSummaryProvider({children}) {
    const [summary, setSummaryState] = useState(null);

    const setSummary = useCallback((value) => {
        setSummaryState((prev) => {
            if (value === null) {
                return prev === null ? prev : null;
            }
            if (prev
                && prev.title === value.title
                && prev.meta === value.meta
                && prev.actions === value.actions) {
                return prev;
            }
            return value;
        });
    }, []);

    const value = useMemo(() => ({summary, setSummary}), [summary, setSummary]);

    return (
        <DetailHeroSummaryContext.Provider value={value}>
            {children}
        </DetailHeroSummaryContext.Provider>
    );
}

export function useDetailHeroSummary() {
    return useContext(DetailHeroSummaryContext)?.summary ?? null;
}

/** 요약을 hero로 올리고 인라인 summary bar는 숨김 */
export function useRegisterDetailHeroSummary({title, meta, actions, revisionKey = 0, active = true, trackActions = false}) {
    const ctx = useContext(DetailHeroSummaryContext);
    const setSummary = ctx?.setSummary;
    const actionsRef = useRef(actions);
    actionsRef.current = actions;

    // trackActions=true 인 경우 actions 참조가 바뀔 때마다 재등록(등록/접수 화면처럼
    // 버튼 onClick 이 최신 상태를 참조해야 하는 경우). 이 경우 actions 는 상위(프로바이더 밖)
    // 컴포넌트의 prop 으로 내려오므로 setSummary 로 인한 재렌더에서는 참조가 유지되어 무한 루프가 없다.
    const actionsDep = trackActions ? actions : null;

    useEffect(() => {
        if (!setSummary || !active) {
            return undefined;
        }

        setSummary({
            title,
            meta,
            actions: actionsRef.current,
        });

        return () => setSummary(null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [setSummary, title, meta, revisionKey, active, actionsDep]);

    return {
        hideInlineSummaryBar: Boolean(active && ctx),
    };
}
